import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { AppConfig } from "./../../app/app.config";

import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";

import sha256 from "crypto-js/sha256";

import * as _ from "underscore";

@Injectable()
export class BqApiProvider {
  private currentCampaign: any;
  private currentData: any;
  private currentUUID: string;

  private _steps: any;
  private _comments: any;
  private _synced: boolean;
  private _syncTimestamp: any;

  private _pendingSteps: any;

  constructor(public http: HttpClient) {
    this._steps = [];
    this._comments = [];
    this._synced = false;
    this.currentData = null;
    this._pendingSteps = [];
  }

  dump() {
    console.log("BqApi");
    console.dir(this.currentData);
    console.dir(this._steps);
  }

  getCampaign(apikey: string) {
    let promise = new Promise((resolve, reject) => {
      this.http
        .get(AppConfig.API_URL + "/everest-campaign/" + apikey)
        .toPromise()
        .then((sRes: any) => {
          this.currentCampaign = sRes;
          // this.currentCampaign.categories = sRes.categories;
          resolve(sRes);
        })
        .catch((sErr) => {
          reject(sErr);
        });
    });

    return promise;
  }

  get() {
    console.log("get");
    console.log(this.currentCampaign);
    return this.currentCampaign || null;
  }

  setEverestData(data: any) {
    let promise = new Promise((resolve, reject) => {
      if (!this.currentUUID) {
        this.currentUUID = sha256(JSON.stringify(this.currentData)).toString();
        window.localStorage.setItem("BQ360Everest::UUID", this.currentUUID);
      }

      this.currentData = {
        name: data.name,
        date: data.date,
        profile: data.profile,
        category: data.category,
        visitTime: data.visitTime,
        store: data.store,
        uuid: this.currentUUID,
      };

      window.localStorage.setItem(
        "BQ360Everest::Data::" + this.currentUUID,
        JSON.stringify(this.currentData)
      );
      resolve();
    });
    return promise;
  }

  getEverestData() {
    return this.currentData;
  }

  setStep(step: any, data: any) {
    console.log("[%cSTEP%c] " + step + "-> %o", "color: orange", "", data);
    this._steps[step] = data;

    this._synced = false;
  }

  setComment(section: any, comment: any) {
    this._comments[section] = comment;
  }

  getComment(section: any) {
    return this._comments[section] || "";
  }

  syncSteps() {
    window.localStorage.setItem(
      "BQ360Everest::Steps::" + this.currentUUID,
      JSON.stringify(this._steps)
    );
    window.localStorage.setItem(
      "BQ360Everest::Comments::" + this.currentUUID,
      JSON.stringify(this._comments)
    );
  }

  resume(uuid: string, data: any, steps: any, comments: any) {
    this.currentUUID = uuid;
    this.currentData = data;
    this._comments = comments;
    this._steps = steps;
  }

  getPendingSteps() {
    return this._pendingSteps;
  }

  addPendingStep(step: any) {
    let prev = _.find(this._pendingSteps, (s) => {
      return s === step;
    });

    if (!prev) {
      this._pendingSteps.push(step);
    }
  }

  getStep(step: any) {
    return this._steps[step];
  }

  traceValidation(text: string) {
    console.log("[ %cValidation%c ] %s", "color: orange", "", text);
  }

  validate() {
    let isValid = true;
    this._pendingSteps = [];

    if (this.getStep(11)) {
      if (this.getStep(11) === 3 && !this.getStep(12)) {
        this.traceValidation(
          "Step 11 has 3 value but step 12 is not answered!"
        );
        this.addPendingStep(12);
        isValid = false;
      }

      if (
        (this.getStep(11) === 1 || this.getStep(11) === 2) &&
        !this.getStep(13) &&
        !this.getStep(14) &&
        !this.getStep(15) &&
        !this.getStep(17) &&
        !this.getStep(18) &&
        !this.getStep(19)
      ) {
        if (!this.getStep(13)) this.addPendingStep(13);
        if (!this.getStep(14)) this.addPendingStep(14);
        if (!this.getStep(15)) this.addPendingStep(15);
        if (!this.getStep(16)) this.addPendingStep(16);
        if (!this.getStep(17)) this.addPendingStep(17);
        if (!this.getStep(18)) this.addPendingStep(18);
        if (!this.getStep(19)) this.addPendingStep(19);

        this.traceValidation(
          "Step 11 has 1/2 value but step 13/14/15/16/17/18 or 19 is not answered!"
        );
        isValid = false;
      }
    }

    if (
      (this.getStep(51) === 1 || this.getStep(51) === 2) &&
      !this.getStep(52)
    ) {
      this.addPendingStep(52);
      this.traceValidation(
        "Step 51 has 1/2 value but step 52 is not answered!"
      );
      isValid = false;
    }

    if (!this.getStep(1)) {
      this.addPendingStep(1);
      this.traceValidation("Step 1 is not answered!");
      isValid = false;
    }

    if (!this.getStep(2)) {
      this.addPendingStep(2);
      this.traceValidation("Step 2 is not answered!");
      isValid = false;
    }

    if (this.getStep(3) && this.getStep(3) === 1) {
      if (!this.getStep(4)) {
        this.addPendingStep(4);
        this.traceValidation("Step 4 is not answered!");
        isValid = false;
      }
      if (!this.getStep(5)) {
        this.addPendingStep(5);
        this.traceValidation("Step 5 is not answered!");
        isValid = false;
      }

      if (!this.getStep(7)) {
        this.addPendingStep(7);
        this.traceValidation("Step 7 is not answered!");
        isValid = false;
      }
      if (!this.getStep(8)) {
        this.addPendingStep(8);
        this.traceValidation("Step 8 is not answered!");
        isValid = false;
      }
      if (!this.getStep(9)) {
        this.addPendingStep(9);
        this.traceValidation("Step 9 is not answered!");
        isValid = false;
      }
      if (!this.getStep(10)) {
        this.addPendingStep(10);
        this.traceValidation("Step 10 is not answered!");
        isValid = false;
      }
      if (!this.getStep(11)) {
        this.addPendingStep(11);
        this.traceValidation("Step 11 is not answered!");
        isValid = false;
      }
    }

    for (let x = 20; x <= 58; x++) {
      if (!this.getStep(x)) {
        if (
          x !== 33 &&
          x !== 34 &&
          x !== 38 &&
          x !== 39 &&
          x !== 40 &&
          x !== 41 &&
          x !== 52 &&
          x !== 54
        ) {
          this.traceValidation("Step " + x + " is not answered");
          this.addPendingStep(x);
          isValid = false;
        }
      }
    }

    if (!this.getStep(301)) {
      this.addPendingStep(30);
      this.traceValidation("Step 301 is not answered!");
      isValid = false;
    }
    if (!this.getStep(341)) {
      this.addPendingStep(34);
      this.traceValidation("Step 341 is not answered!");
      isValid = false;
    }
    if (!this.getStep(342)) {
      this.addPendingStep(34);
      this.traceValidation("Step 342 is not answered!");
      isValid = false;
    }

    this.traceValidation("Validation result: " + isValid);

    return isValid;
  }

  upload() {
    let promise = new Promise((resolve, reject) => {
      let payLoad = {
        data: this.currentData,
        answers: this._steps,
        comments: this._comments,
      };

      this.http
        .post(AppConfig.API_URL + "/everest-upload", payLoad)
        .toPromise()
        .then((r) => {
          resolve(r);
        })
        .catch((err) => {
          reject(err);
        });
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/providers/bq-api/bq-api.ts